<div #formModal class="modal fade" id="ask_project" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Request a new project creation</h3>
      </div>
      <form #projectForm="ngForm" aria-label="project creation request form" role="form" class="user-form form-horizontal was-validated" (ngSubmit)="ask_for_project(projectForm)" novalidate>
        <div class="modal-body">
          <div class="form-group row col-sm-12">
            <label for="new_project_id">
              Name
              <span style="color: red">(required) </span>
              <i class="pi pi-question-circle" title="Unique name for the project"></i>
            </label>
            <input required placeholder="project name" type="text" maxlength="42" id="new_project_id" name="id" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.id" class="form-control" #id="ngModel" />
            <small id="nameHelp" class="form-text text-muted">Avoid generic name, team name, technology name or your name. <b>Please, choose a project name that matches your cluster research project</b>. <i>If you work on several projects, you can request more project spaces.</i></small>
            @if (id.invalid && (id.dirty || id.touched)) {
              <div class="text-danger">
                @if (id.errors.required) {
                  <div>Name is required</div>
                }
                @if (id.errors.maxlength) {
                  <div>Name can't be more than 42 characters long</div>
                }
              </div>
            }
          </div>

          <div class="form-group row col-sm-12">
            <label for="new_project_expire">
              Expiration date
              <span style="color: red">(required) </span>
              <i class="pi pi-question-circle" title="Project expiration date"></i>
            </label>
            <input required type="date" id="new_project_expire" name="expire" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project_expire" class="form-control" #expire="ngModel" />
            @if (expire.invalid && (expire.dirty || expire.touched)) {
              <div class="text-danger">
                @if (expire.errors.required) {
                  <div>Expiration date is required</div>
                }
              </div>
            }
          </div>

          <div class="form-group row col-sm-12">
            <label for="new_project_size">Total expected project size (GB)</label>
            <input placeholder="project size in GB" type="number" id="new_project_size" name="size" [value]="default_size" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.size" class="form-control" />
            <small id="nameHelp" class="form-text text-muted">
              <i>Please include the <b>total</b> expected size for this project.</i>
            </small>
          </div>

          <div class="form-group row col-sm-12">
            <label for="new_project_cpu">Cpu (Hour)</label>
            <input placeholder="project cpu in Hour" type="number" id="new_project_cpu" name="cpu" [value]="default_cpu" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.cpu" class="form-control" />
            <small id="nameHelp" class="form-text text-muted"><i>Optional, for information only</i></small>
          </div>

          <div class="form-group row col-sm-12">
            <label for="new_project_org">
              Financing
              <span class="pi pi-question-circle" title="Entity financing the project" tooltip> </span>
            </label>
            <input placeholder="Ex : CNRS" type="text" id="new_project_org" name="orga" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.orga" class="form-control" />
            <small id="orgaHelp" class="form-text text-muted"><em>Optional, for information only</em></small>
          </div>

          <div class="form-group row col-sm-12">
            <label for="new_project_description">Description <span style="color: red">(required)</span> </label>
            <textarea required placeholder="A description for the project" minlength="30" rows="2" id="new_project_description" name="description" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.description" class="form-control" #description="ngModel"></textarea>
            @if (description.invalid && (description.dirty || description.touched)) {
              <div class="text-danger">
                @if (description.errors.minlength) {
                  <div>Description must be at least 30 characters long</div>
                }
              </div>
            }
          </div>

          @if (config.project && config.project.terms_and_conditions_hds) {
            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input is-invalid" type="checkbox" value="" id="new_project_terms_and_conditions_hds" name="terms_and_conditions_hds" [(ngModel)]="new_project.terms_and_conditions_hds" #terms_and_conditions_hds="ngModel" required />
                <label class="form-check-label" for="new_project_terms_and_conditions_hds">
                  I hereby certify that I will not upload, store or process health data collected during activities of prevention, diagnostic and care or related to social and medical and social follow-up.
                  <a href="#termsAndConditionsHdsModal" data-bs-toggle="modal">(Learn more)</a>
                </label>
                @if (terms_and_conditions_hds.invalid) {
                  <div class="invalid-feedback">You must agree to the terms and conditions before submitting.</div>
                }
              </div>
            </div>
          }
        </div>
        <div class="modal-footer" id="submit">
          <div class="form-group row col-sm-12">
            <!-- Button with terms_and_conditions_hds -->
            @if (config.project && config.project.terms_and_conditions_hds) {
              <p-button severity="primary" size="small" id="test" type="submit" [disabled]="id.invalid || expire.invalid || description.invalid || terms_and_conditions_hds.invalid" [ngstyleClass]="{ 'disabled-btn': id.invalid || expire.invalid || description.invalid || terms_and_conditions_hds.invalid }" label="Ask Admin"></p-button>
            }
            <!-- Button without terms_and_conditions_hds -->
            @if (!(config.project && config.project.terms_and_conditions_hds)) {
              <p-button severity="primary" size="small" id="test" type="submit" [disabled]="id.invalid || expire.invalid || description.invalid" [ngstyleClass]="{ 'disabled-btn': id.invalid || expire.invalid || description.invalid }" label="Ask Admin"></p-button>
            }
            <button type="button" class="p-button p-button-sm p-button-secondary" data-bs-dismiss="modal">Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
@if (session_user) {
  <p-button type="button" size="small" severity="primary" data-bs-toggle="modal" data-bs-target="#ask_project" label="Request A New Project"></p-button>
}


<div class="card bg-light">
  <div class="card-header" (click)="projects_visible=!projects_visible" style="cursor: pointer;">
    <h3>Projects</h3>
  </div>
  @if (projects_visible) {
    <div class="card-body">
      <div class="table-responsive">
        <p-table #dtp [value]="projects" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['id', 'owner']" [filterDelay]="0">
          <ng-template pTemplate="caption">
            <span class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <input pInputText id="search_projects" type="text" (input)="dtp.filterGlobal($event.target.value, 'contains')" placeholder="Search" />
            </span>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>Project</th>
              <th>Owner</th>
              @if (!config.project || config.project.enable_group) {
                <th>Group</th>
              }
              <th>Path</th>
              <th>Size (GB)</th>
              <th>Cpu (Hour)</th>
              <th>Creation</th>
              <th>Expiration</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-project>
            <tr>
              <td (click)="show_project_users_and_scroll(project, selectedProjectAnchor)" style="cursor: pointer">
                <span class="p-button p-button-sm p-button-primary">{{ project.id }}</span>
              </td>
              <td>{{ project.owner }}</td>
              @if (!config.project || config.project.enable_group) {
                <td>{{ project.group }}</td>
              }
              <td>{{ project.path }}</td>
              <td>
                @if (project.current_size) {
                  <span>{{ project.current_size }}&#47;</span>
                  }{{ project.size }}
                  @if (project.current_size) {
                    <meter min="0" max="{{ project.size }}" optimum="0" low="{{ project.low_size }}" high="{{ project.high_size }}" value="{{ project.current_size }}"></meter>
                  }
                </td>
                <td>
                  @if (project.current_cpu) {
                    <span>{{ project.current_cpu }}&#47;</span>
                    }{{ project.cpu }}
                    @if (project.current_cpu) {
                      <meter min="0" max="{{ project.cpu }}" optimum="0" low="{{ project.low_cpu }}" high="{{ project.high_cpu }}" value="{{ project.current_cpu }}"></meter>
                    }
                  </td>
                  <td>{{ project.created_at | date }}</td>
                  <td>{{ project.expire | date }}</td>
                  <td>
                    @if (!session_user.is_admin && project.owner != session_user.uid) {
                      <p-button severity="warn" size="small" type="button" (onClick)="request_user(project, session_user.uid, 'remove')" label="Leave project"></p-button>
                    }
                    @if (session_user.is_admin) {
                      <a routerLink="/admin/project/{{ project.id }}"><span class="p-button p-button-sm p-button-danger">Admin</span></a>
                    }
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      }
    </div>


    @if (request_err_msg) {
      <div class="alert alert-danger">{{ request_err_msg }}</div>
    }
    @if (request_msg) {
      <div class="alert alert-info">{{ request_msg }}</div>
    }


    <a #selectedProjectAnchor></a>
    @if (selectedProject) {
      <div>
        <hr />
        <div class="well">
          <h2>
            Project <b>{{ selectedProject.id }}</b>
          </h2>
        </div>
        @if (session_user.uid === selectedProject.owner) {
          <div class="card bg-light">
            <div class="card-header" (click)="owner_visible = !owner_visible" style="cursor: pointer;">
              <h3>Owner console</h3>
            </div>
            @if (owner_visible) {
              <div class="card-body">
                @if (owner_request_err_msg) {
                  <div class="alert alert-danger">{{owner_request_err_msg}}</div>
                }
                @if (owner_request_msg) {
                  <div class="alert alert-info">{{owner_request_msg}}</div>
                }
                <form role="form" class="user-form form-horizontal">
                  <div class="form-group row">
                    <div class="col-sm-3">
                      <label for="new_manager">New project manager</label>
                      <select id="add_manager"  [ngModelOptions]="{standalone: true}" [(ngModel)]="new_manager" class="form-control">
                        @for (user of users; track user) {
                          <option [value]="user.uid">{{user.uid}}</option>
                        }
                      </select>
                    </div>
                    <div class="col-sm-3">
                      <label style="opacity: 0;">Add new manager</label>
                      <p-button severity="success" size="small" type="button" (onClick)="add_manager(selectedProject, new_manager)" label="Promote to Manager"></p-button>
                    </div>
                    <div class="col-sm-3">
                      <label for="rm_manager">Remove project manager</label>
                      <select id="rm_manager"  [ngModelOptions]="{standalone: true}" [(ngModel)]="rm_manager" class="form-control">
                        @for (manager of selectedProject.managers; track manager) {
                          <option [value]="manager">{{manager}}</option>
                        }
                      </select>
                    </div>
                    <div class="col-sm-3">
                      <label style="opacity: 0;">Remove manager</label>
                      <p-button severity="danger" size="small" type="button" (onClick)="remove_manager(selectedProject, rm_manager)" label="Demote to Member"></p-button>
                    </div>
                  </div>
                </form>
                <h6>Project managers :</h6>
                <ul>
                  @for (manager of selectedProject.managers; track manager) {
                    <li>{{ manager }}</li>
                  }
                </ul>
              </div>
            }
          </div>
        }
        @if (selectedProject.managers.includes(session_user.uid)) {
          <div class="card bg-light">
            <div class="card-header" (click)="manager_visible = !manager_visible" style="cursor: pointer;">
              <h3>Manager console</h3>
            </div>
            @if (manager_visible) {
              <div class="card-body">
                @if (manager_request_err_msg) {
                  <div class="alert alert-danger">{{manager_request_err_msg}}</div>
                }
                @if (manager_request_msg) {
                  <div class="alert alert-info">{{manager_request_msg}}</div>
                }
                <form role="form" class="user-form form-horizontal">
                  <div class="form-group row">
                    <div class="col-sm-3">
                      <label for="new_user">New project member</label>
                      <input placeholder="User id" id="new_user" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_user" class="form-control" />
                    </div>
                    <div class="col-sm-3">
                      <label style="opacity: 0;">Request new member</label>
                      <p-button severity="primary" size="small" type="button" (onClick)="request_user(selectedProject, new_user, 'add')" label="Request New Member"></p-button>
                    </div>
                    <div class="col-sm-3">
                      <label for="remove_user">Remove project member</label>
                      <select id="remove_user" [ngModelOptions]="{ standalone: true }" [(ngModel)]="remove_user" class="form-control">
                        @for (user of users; track user) {
                          <option [value]="user.uid">{{ user.uid }}</option>
                        }
                      </select>
                    </div>
                    <div class="col-sm-3">
                      <label style="opacity: 0;">Request member removal</label>
                      <p-button severity="warn" size="small" type="button" (onClick)="request_user(selectedProject, remove_user, 'remove')" label="Request Member Removal"></p-button>
                    </div>
                  </div>
                </form>
              </div>
            }
          </div>
        }
        <div class="card bg-light">
          <div class="card-header" (click)="overview_visible=!overview_visible" style="cursor: pointer;">
            <h3>Project overview</h3>
          </div>
          @if (overview_visible) {
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped">
                  <tbody>
                    <tr>
                      <td>
                        <b>Name</b>&nbsp;
                        <span class="glyphicon glyphicon-question-sign" title="Project name" tooltip> </span>
                      </td>
                      <td>{{ selectedProject.id }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>Owner</b>&nbsp;
                        <span class="glyphicon glyphicon-question-sign" title="Owner uid" tooltip> </span>
                      </td>
                      <td>{{ selectedProject.owner }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>Unix Group</b>&nbsp;
                        <span class="glyphicon glyphicon-question-sign" title="Unix group for members" tooltip></span>
                      </td>
                      <td>{{ selectedProject.group }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>Path</b>&nbsp;
                        <span class="glyphicon glyphicon-question-sign" title="Path to project folder" tooltip></span>
                      </td>
                      <td>{{ selectedProject.path }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>Size</b>&nbsp;
                        <span class="glyphicon glyphicon-question-sign" title="Storage quota" tooltip></span>
                      </td>
                      <td>
                        @if (selectedProject.current_size) {
                          <span>{{ selectedProject.current_size }}&#47;</span>
                          }{{ selectedProject.size }} GB
                          @if (selectedProject.current_size) {
                            <meter min="0" max="{{ selectedProject.size }}" optimum="0" low="{{ selectedProject.low_size }}" high="{{ selectedProject.high_size }}" value="{{ selectedProject.current_size }}"></meter>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>Cpu</b>&nbsp;
                          <span class="glyphicon glyphicon-question-sign" title="Cpu quota" tooltip></span>
                        </td>
                        <td>
                          @if (selectedProject.current_cpu) {
                            <span>{{ selectedProject.current_cpu }}&#47;</span>
                            }{{ selectedProject.cpu }} Hour
                            @if (selectedProject.current_cpu) {
                              <meter min="0" max="{{ selectedProject.cpu }}" optimum="0" low="{{ selectedProject.low_cpu }}" high="{{ selectedProject.high_cpu }}" value="{{ selectedProject.current_cpu }}"></meter>
                            }
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>Creation</b>&nbsp;
                            <span class="glyphicon glyphicon-question-sign" title="Creation date" tooltip></span>
                          </td>
                          <td>{{ selectedProject.created_at | date }}</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Expiration</b>&nbsp;
                            <span class="glyphicon glyphicon-question-sign" title="Expiration date" tooltip></span>
                          </td>
                          <td>{{ selectedProject.expire | date }} &nbsp; @if (config.project && config.project.allow_extend) {
                            <p-button severity="success" size="small" (onClick)="extend(selectedProject)" label="Extend validity"></p-button>
                          }</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Financing</b>&nbsp;
                            <span class="glyphicon glyphicon-question-sign" title="Organism financing the project" tooltip></span>
                          </td>
                          <td>{{ selectedProject.orga }}</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Write permissions</b>&nbsp;
                            <span class="glyphicon glyphicon-question-sign" data-html="true" title="Write access<br>Group : all members<br>Data manager : owner" tooltip></span>
                          </td>
                          <td>{{ selectedProject.access }}</td>
                        </tr>
                        <tr>
                          <td>
                            <b>Description</b>&nbsp;
                            <span class="glyphicon glyphicon-question-sign" title="Short project description" tooltip></span>
                          </td>
                          <td>{{ selectedProject.description }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            </div>
            <div class="card bg-light">
              <div class="card-header" (click)="members_visible=!members_visible" style="cursor: pointer;">
                <h3>Project members</h3>
              </div>
              @if (members_visible) {
                <div class="card-body">
                  <div class="table-responsive table-striped">
                    <p-table #dtu [value]="users" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]">
                      <ng-template pTemplate="header">
                        <tr>
                          <th>User</th>
                          <th>Email</th>
                          <th>Access?</th>
                          <th>Manager?</th>
                          <th>Owner?</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-user>
                        <tr>
                          <td>{{ user.uid }}</td>
                          <td>
                            @if (session_user.uid === selectedProject.owner) {
                              <span>{{ user.email }}</span>
                            }
                            @if (session_user.uid !== selectedProject.owner) {
                              <span>Restricted to owner</span>
                            }
                          </td>
                          <td>@if (user.temp?.access) {
                            <span>x</span>
                          }</td>
                          <td>@if (user.temp?.is_manager) {
                            <span>x</span>
                          }</td>
                          <td>@if (user.uid === selectedProject.owner) {
                            <span>x</span>
                          }</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              }
            </div>
          </div>
        }


        @if (config.project && config.project.terms_and_conditions_hds) {
          <div #termsAndConditionsHdsModal class="modal fade" id="termsAndConditionsHdsModal" data-backdrop="static" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Terms and Conditions HDS</h4>
                </div>
                <div class="container"></div>
                <div class="modal-body">
                  <p>As our computing infrastructure is not HDS-certified (Health Data Hosting), health data collected during activities of prevention, diagnostic and care or related to social and medical and social follow-up cannot be uploaded, stored or processed (article L.1111-8, French Public Health Code).</p>
                </div>
                <div class="modal-footer">
                  <p-button type="button" styleClass="btn btn-secondary" data-bs-dismiss="modal" label="Close"></p-button>
                </div>
              </div>
            </div>
          </div>
        }
